import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../components/Layout';
// const NAV = [
//   { icon: '⬡',  label: 'Dashboard',       path: '/dashboard'      },
//   { icon: '👥',  label: 'User Management', path: '/user-management' },
// //   { icon: '🌤️', label: 'Season Name',      path: '/season-name'    },
// //   { icon: '📅',  label: 'Season Duration',  path: '/season-duration'   },
// {
//     icon: '🌤️',
//     label: 'Season Management',
//     children: [
//       { icon: '🌤️', label: 'Season Name', path: '/season-name' },
//       { icon: '📅', label: 'Season Duration', path: '/season-duration' }
//     ]
//   },
//   {icon:'⏱️', label:'Rent Durations',  path:'/rent-durations'},
//   { icon: '📋',  label: 'Bookings',        path: '/bookings'       },
//   { icon: '🚘',  label: 'Vehicles',        path: '/vehicles'       },
//   { icon: '👤',  label: 'Customers',       path: '/customers'      },
//   { icon: '💳',  label: 'Payments',        path: '/payments'       },
// ];

export default function SeasonName() {
  const navigate = useNavigate();

  // ── Sidebar ──
  const [sideOpen,   setSideOpen]   = useState(true);
  const [activePage, setActivePage] = useState('Season Name');
  const [user,       setUser]       = useState(null);

  // ── Table ──
  const [data,       setData]       = useState([]);
  const [page,       setPage]       = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total,      setTotal]      = useState(0);
  const [search,     setSearch]     = useState('');
  const [loading,    setLoading]    = useState(false);

  // ── Form ──
  const [name,       setName]       = useState('');
  const [editId,     setEditId]     = useState(null);
  const [saving,     setSaving]     = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  // ── Auth ──
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { navigate('/login'); return; }
    setUser(JSON.parse(localStorage.getItem('user') || 'null'));
  }, []);

  // ── Fetch ──
  const fetchData = useCallback(async (pg = page, q = search) => {
    setLoading(true);
    try {
      const res = await API.get('/seasons', { params: { page: pg, limit: 10, search: q } });
      setData(res.data.data);
      setTotalPages(res.data.totalPages);
      setTotal(res.data.total);
    } catch {
      toast.error('Failed to load seasons');
    }
    setLoading(false);
  }, [page, search]);

  useEffect(() => { fetchData(page, search); }, [page]);

  // debounce search
  useEffect(() => {
    const t = setTimeout(() => { setPage(1); fetchData(1, search); }, 350);
    return () => clearTimeout(t);
  }, [search]);

  // ── Add / Update ──
  const handleSubmit = async () => {
    if (!name.trim()) { toast.warning('Enter season name'); return; }
    setSaving(true);
    try {
      if (editId) {
        await API.put(`/seasons/${editId}`, { name: name.trim() });
        toast.success('Season updated');
      } else {
        await API.post('/seasons', { name: name.trim() });
        toast.success('Season added');
      }
      setName(''); setEditId(null);
      fetchData(page, search);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Operation failed');
    }
    setSaving(false);
  };

  // ── Edit ──
  const handleEdit = (row) => {
    setName(row.period_name);
    setEditId(row.period_id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ── Cancel edit ──
  const handleCancel = () => { setName(''); setEditId(null); };

  // ── Delete ──
  const handleDelete = async (id) => {
    if (!window.confirm('Delete this season?')) return;
    try {
      await API.delete(`/seasons/${id}`);
      toast.success('Deleted successfully');
      fetchData(page, search);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Delete failed');
    }
  };

  const logout = () => { localStorage.clear(); navigate('/login'); };

  return (
    <Layout activePage="Season Details">
    {/* <div style={S.root}> */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* ── Sidebar ── */}
      {/* <aside style={{ ...S.sidebar, width: sideOpen ? 220 : 68 }}>
        <div style={S.sideTop}>
          <div style={S.logoWrap}>
            <div style={S.logoIcon}>🚗</div>
            {sideOpen && <span style={S.logoText}>Orisys</span>}
          </div>
          <button style={S.collapseBtn} onClick={() => setSideOpen(p => !p)}>
            {sideOpen ? '◀' : '▶'}
          </button>
        </div>

        <nav style={{ flex: 1 }}>
  {NAV.map((n, i) => (
    <div key={i}> */}
      
      {/* Parent Item */}
      {/* <div
        style={{
          ...S.navItem,
          ...(activePage === n.label ? S.navActive : {})
        }}
        onClick={() => {
          if (n.children) {
            setOpenMenu(openMenu === n.label ? null : n.label);
          } else {
            setActivePage(n.label);
            navigate(n.path);
          }
        }}
      >
        <span style={S.navIcon}>{n.icon}</span>
        {sideOpen && (
          <>
            <span style={S.navLabel}>{n.label}</span>
            {n.children && (
              <span style={{ marginLeft: 'auto' }}>
                {openMenu === n.label ? '▲' : '▼'}
              </span>
            )}
          </>
        )}
      </div> */}

      {/* Child Items */}
      {/* {n.children && openMenu === n.label && (
        <div style={{ marginLeft: sideOpen ? 30 : 0 }}>
          {n.children.map((child, j) => (
            <div
              key={j}
              style={{
                ...S.navItem,
                fontSize: 13,
                paddingTop: '8px',
                paddingBottom: '8px',
                color: '#ccc'
              }}
              onClick={() => {
                setActivePage(child.label);
                navigate(child.path);
              }}
            >
              <span style={S.navIcon}>{child.icon}</span>
              {sideOpen && (
                <span style={S.navLabel}>{child.label}</span>
              )}
            </div>
          ))}
        </div>
      )}

    </div>
  ))}
</nav>

        <div style={S.sideBottom}>
          {sideOpen && (
            <div style={S.userChip}>
              <div style={S.avatar}>{user?.user_name?.[0] || 'A'}</div>
              <div>
                <div style={S.userName}>{user?.user_name || 'Admin'}</div>
                <div style={S.userRole}>Administrator</div>
              </div>
            </div>
          )}
          <button style={S.logoutBtn} onClick={logout}>
            <span>🚪</span>{sideOpen && <span style={{ marginLeft: 8 }}>Logout</span>}
          </button>
        </div>
      </aside> */}

      {/* ── Main ── */}
      <main>

        {/* Header */}
        <div style={S.header}>
          <div>
            <h2 style={S.title}>Season Management</h2>
            <p style={S.subtitle}>Add and manage rental season periods</p>
          </div>
        </div>

        {/* Card */}
        <div style={S.card}>

          {/* Top Controls */}
          <div style={S.topRow}>
            {/* Search */}
            <div style={S.searchWrap}>
              <span style={{ fontSize: 14, color: '#aaa' }}>🔍</span>
              <input
                type="text"
                placeholder="Search season..."
                value={search}
                onChange={e => { setSearch(e.target.value); setPage(1); }}
                style={S.search}
              />
              {search && (
                <button style={S.clearBtn} onClick={() => setSearch('')}>✕</button>
              )}
            </div>

            {/* Inline Form */}
            <div style={S.formRow}>
              {editId && <span style={S.editingBadge}>Editing #{editId}</span>}
              <input
                type="text"
                placeholder="Enter Season Name"
                value={name}
                onChange={e => setName(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                style={S.input}
              />
              {editId && (
                <button onClick={handleCancel} style={S.cancelBtn}>Cancel</button>
              )}
              <button onClick={handleSubmit} style={S.btn} disabled={saving}>
                {saving ? '...' : editId ? 'Update' : 'Add'}
              </button>
            </div>
          </div>

          {/* Table */}
          <div style={{ overflowX: 'auto' }}>
            <table style={S.table}>
              <thead>
                <tr style={S.theadRow}>
                  <th style={S.th}>#</th>
                  <th style={S.th}>Season Name</th>
                  <th style={S.th}>Created Date</th>
                  <th style={S.th}>Last Updated</th>
                  <th style={{ ...S.th, textAlign: 'right' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={5} style={S.emptyCell}>Loading…</td></tr>
                ) : data.length === 0 ? (
                  <tr><td colSpan={5} style={S.emptyCell}>No seasons found</td></tr>
                ) : data.map((row, i) => (
                  <tr key={row.period_id} style={{
                    ...S.tr,
                    background: editId === row.period_id ? '#f3f2ff' : 'transparent'
                  }}>
                    <td style={S.td}>
                      <span style={S.serial}>{(page - 1) * 10 + i + 1}</span>
                    </td>
                    <td style={S.td}>
                      <span style={S.nameChip}>{row.period_name}</span>
                    </td>
                    <td style={{ ...S.td, color: '#999', fontSize: 12 }}>
                      {row.period_createddate
                        ? new Date(row.period_createddate).toLocaleDateString('en-IN', {
                            day: '2-digit', month: 'short', year: 'numeric'
                          })
                        : '—'}
                    </td>
                    <td style={{ ...S.td, color: '#999', fontSize: 12 }}>
                      {row.period_lastupdated
                        ? new Date(row.period_lastupdated).toLocaleDateString('en-IN', {
                            day: '2-digit', month: 'short', year: 'numeric'
                          })
                        : '—'}
                    </td>
                    <td style={{ ...S.td, textAlign: 'right' }}>
                      <button onClick={() => handleEdit(row)} style={S.editBtn}>Edit</button>
                      <button onClick={() => handleDelete(row.period_id)} style={S.delBtn}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div style={S.pagination}>
            <span style={S.paginInfo}>
              {total > 0
                ? `Showing ${(page - 1) * 10 + 1}–${Math.min(page * 10, total)} of ${total}`
                : ''}
            </span>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <button style={S.pgBtn} disabled={page === 1}
                onClick={() => setPage(p => p - 1)}>← Prev</button>
              <span style={S.paginInfo}>Page {page} / {totalPages}</span>
              <button style={S.pgBtn} disabled={page === totalPages || totalPages === 0}
                onClick={() => setPage(p => p + 1)}>Next →</button>
            </div>
          </div>

        </div>
      </main>
    {/* </div> */}
    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
  root: {
    display: 'flex', minHeight: '100vh',
    background: '#f4f6fb', fontFamily: "'DM Sans','Segoe UI',sans-serif"
  },

  /* Sidebar */
  // sidebar: {
  //   background: '#1a1d2e', color: '#fff', display: 'flex', flexDirection: 'column',
  //   position: 'fixed', height: '100vh', transition: 'width 0.25s', overflow: 'hidden', zIndex: 100
  // },
  // sideTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 16px 16px' },
  // logoWrap: { display: 'flex', alignItems: 'center', gap: 10 },
  // logoIcon: {
  //   width: 36, height: 36, background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
  //   borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center',
  //   fontSize: 18, flexShrink: 0
  // },
  // logoText: { fontSize: 18, fontWeight: 800, letterSpacing: '-0.5px', whiteSpace: 'nowrap' },
  // collapseBtn: {
  //   background: 'rgba(255,255,255,0.08)', border: 'none', color: '#aaa',
  //   borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 11, flexShrink: 0
  // },
  // navItem: {
  //   display: 'flex', alignItems: 'center', gap: 12,
  //   paddingTop: '11px', paddingBottom: '11px', paddingLeft: '16px', paddingRight: '16px',
  //   cursor: 'pointer', borderRadius: 10, margin: '2px 10px',
  //   color: '#aaa', fontSize: 14, transition: 'all 0.15s', whiteSpace: 'nowrap'
  // },
  // navActive: {
  //   background: 'rgba(99,179,237,0.12)', color: '#63b3ed',
  //   borderLeft: '3px solid #63b3ed', paddingLeft: '13px'
  // },
  // navIcon: { fontSize: 16, flexShrink: 0 },
  // navLabel: { fontWeight: 500 },
  // sideBottom: { padding: '16px', borderTop: '1px solid rgba(255,255,255,0.07)' },
  // userChip: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 },
  // avatar: {
  //   width: 36, height: 36, background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
  //   borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
  //   fontWeight: 800, fontSize: 15, flexShrink: 0
  // },
  // userName: { fontSize: 13, fontWeight: 700, color: '#fff' },
  // userRole: { fontSize: 11, color: '#777' },
  // logoutBtn: {
  //   width: '100%', background: 'rgba(255,100,100,0.12)', border: '1px solid rgba(255,100,100,0.2)',
  //   color: '#ff6b6b', borderRadius: 8, padding: '8px 12px', cursor: 'pointer', fontSize: 13,
  //   display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'inherit'
  // },

  /* Main */
  main: { flex: 1, padding: '28px 28px 40px', minWidth: 0, transition: 'margin-left 0.25s' },

  /* Header */
  header: { marginBottom: 20 },
  title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
  subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },

  /* Card */
  card: {
    background: '#fff', borderRadius: 16,
    boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden'
  },

  /* Top row */
  topRow: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    flexWrap: 'wrap', gap: 12, padding: '18px 20px',
    borderBottom: '1px solid #f0f0f0'
  },
  searchWrap: {
    display: 'flex', alignItems: 'center', gap: 8,
    background: '#f8f8f8', border: '1px solid #e8e8e8',
    borderRadius: 10, padding: '8px 14px', minWidth: 220
  },
  search: {
    border: 'none', outline: 'none', fontSize: 13,
    background: 'transparent', fontFamily: 'inherit', color: '#333', flex: 1
  },
  clearBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 12, padding: 0 },
  formRow: { display: 'flex', alignItems: 'center', gap: 8 },
  editingBadge: {
    fontSize: 11, fontWeight: 700, background: '#f3f2ff', color: '#6C63FF',
    borderRadius: 20, padding: '3px 10px'
  },
  input: {
    padding: '9px 14px', border: '1.5px solid #e0e0e0', borderRadius: 10,
    fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none', width: 220
  },
  cancelBtn: {
    padding: '9px 16px', background: '#f5f5f5', color: '#666',
    border: 'none', borderRadius: 10, cursor: 'pointer',
    fontSize: 13, fontWeight: 600, fontFamily: 'inherit'
  },
  btn: {
    padding: '9px 20px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
    color: '#fff', border: 'none', borderRadius: 10,
    cursor: 'pointer', fontSize: 13, fontWeight: 700, fontFamily: 'inherit'
  },

  /* Table */
  table: { width: '100%', borderCollapse: 'collapse' },
  theadRow: { background: '#fafafa' },
  th: {
    padding: '12px 16px', fontSize: 11, fontWeight: 700, color: '#999',
    textAlign: 'left', borderBottom: '2px solid #f0f0f0',
    textTransform: 'uppercase', letterSpacing: '0.5px'
  },
  tr: { transition: 'background 0.12s' },
  td: { padding: '13px 16px', fontSize: 13, color: '#333', borderBottom: '1px solid #f8f8f8' },
  emptyCell: { textAlign: 'center', padding: 40, color: '#bbb', fontSize: 14 },
  serial: {
    background: '#f3f2ff', color: '#6C63FF',
    borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700
  },
  nameChip: {
    background: '#f0fff6', color: '#1a9e5c',
    borderRadius: 20, padding: '4px 14px', fontSize: 13, fontWeight: 600
  },
  editBtn: {
    marginRight: 6, background: '#f3f2ff', color: '#6C63FF',
    border: '1px solid #d4d0ff', padding: '5px 14px',
    borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit'
  },
  delBtn: {
    background: '#fff2f5', color: '#FF6584',
    border: '1px solid #ffd0d8', padding: '5px 14px',
    borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit'
  },

  /* Pagination */
  pagination: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '14px 20px', borderTop: '1px solid #f0f0f0'
  },
  paginInfo: { fontSize: 12, color: '#999' },
  pgBtn: {
    padding: '5px 14px', background: '#f3f2ff', color: '#6C63FF',
    border: '1px solid #d4d0ff', borderRadius: 8, cursor: 'pointer',
    fontSize: 12, fontWeight: 600, fontFamily: 'inherit'
  },
};